/**
 * @GENERATED from Figma node 693:15961
 */

import { useUniqueInlineId } from "@inline-svg-unique-id/react";
import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const CalculatorBright = function (
  props: IconProps,
  ref: React.Ref<SVGSVGElement>,
) {
  const _id4 = useUniqueInlineId();
  const _id3 = useUniqueInlineId();
  const _id2 = useUniqueInlineId();
  const _id = useUniqueInlineId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      focusable={false}
      role="presentation"
      ref={ref}
      {...props}
    >
      <path
        fill={`url(#${_id})`}
        fillRule="evenodd"
        d="M2 11.925h9.925V2c-4.66 0-7 .01-8.457 1.468S2 7.266 2 11.925"
        clipRule="evenodd"
      />
      <path
        fill={`url(#${_id2})`}
        fillRule="evenodd"
        d="M12.075 2v9.925H22c0-4.66-.01-7-1.468-8.457S16.734 2 12.075 2"
        clipRule="evenodd"
      />
      <path
        fill={`url(#${_id3})`}
        fillRule="evenodd"
        d="M11.925 22v-9.925H2c0 4.66.01 7 1.468 8.457S7.266 22 11.925 22"
        clipRule="evenodd"
      />
      <path
        fill={`url(#${_id4})`}
        d="M22 12.075h-9.925V22c4.66 0 7-.01 8.457-1.468S22 16.734 22 12.075"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M6.55 7.847H4.455V7.1H6.55V5.008h.746V7.1h2.093v.746H7.295V9.94H6.55zm12.763.112h-4.33v-.746h4.33zM5.485 18.967l1.48-1.48 1.48 1.48.527-.527-1.48-1.48 1.48-1.48-.527-.528-1.48 1.48-1.48-1.48-.528.528 1.48 1.48-1.48 1.48zm13.828-2.687h-4.33v-.746h4.33zm0 2.005h-4.33v-.746h4.33z"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient
          id={_id}
          x1={24.5}
          x2={13.032}
          y1={22}
          y2={-8.309}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73C3E2" />
          <stop offset={0.304} stopColor="#B9C0A5" />
          <stop offset={0.654} stopColor="#F1BF8E" />
          <stop offset={0.938} stopColor="#F7F7F7" />
        </linearGradient>
        <linearGradient
          id={_id2}
          x1={24.5}
          x2={13.032}
          y1={22}
          y2={-8.309}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73C3E2" />
          <stop offset={0.304} stopColor="#B9C0A5" />
          <stop offset={0.654} stopColor="#F1BF8E" />
          <stop offset={0.938} stopColor="#F7F7F7" />
        </linearGradient>
        <linearGradient
          id={_id3}
          x1={24.5}
          x2={13.032}
          y1={22}
          y2={-8.309}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73C3E2" />
          <stop offset={0.304} stopColor="#B9C0A5" />
          <stop offset={0.654} stopColor="#F1BF8E" />
          <stop offset={0.938} stopColor="#F7F7F7" />
        </linearGradient>
        <linearGradient
          id={_id4}
          x1={24.5}
          x2={13.032}
          y1={22}
          y2={-8.309}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#73C3E2" />
          <stop offset={0.304} stopColor="#B9C0A5" />
          <stop offset={0.654} stopColor="#F1BF8E" />
          <stop offset={0.938} stopColor="#F7F7F7" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const ForwardRef = React.forwardRef(CalculatorBright);
export { ForwardRef as CalculatorBright };
